function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.37,12.223H2.032a1.785,1.785,0,0,1-.816-.2l5.41-5.246L8.235,8.185a.652.652,0,0,0,.88,0l1.64-1.433,5.436,5.271A1.785,1.785,0,0,1,15.37,12.223ZM.3,11.1h0A2.617,2.617,0,0,1,0,9.875V2.348a2.7,2.7,0,0,1,.066-.6,2.559,2.559,0,0,1,.188-.54l5.392,4.71L.3,11.1Zm16.8,0h0L11.736,5.9l5.4-4.715a2.555,2.555,0,0,1,.2.553,2.694,2.694,0,0,1,.071.614V9.875a2.618,2.618,0,0,1-.3,1.225ZM8.675,6.649a.525.525,0,0,1-.338-.135L1.017.315A1.885,1.885,0,0,1,1.5.082,1.772,1.772,0,0,1,2.032,0H15.37a1.773,1.773,0,0,1,.517.077A1.874,1.874,0,0,1,16.356.3L9.013,6.514A.524.524,0,0,1,8.675,6.649Z",
  fill: "#00b278"
});

var SvgMailIcon = function SvgMailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.402,
    height: 12.223,
    viewBox: "0 0 17.402 12.223",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-icon.0ebc1e7d.svg";
export { ForwardRef as ReactComponent };